export const createDefaultRepresentante = {
  nombreCompleto: "",
  nif: "",
  calle: "",
  numero: "",
  municipio: "",
}
